import React, {useMemo} from 'react'
import {Box, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useGlobalSettingsContentful} from '../../clients/contentful/hooks/use-global-settings-contentful.hook'

const ItemImageDefault = () => {
    const {data: globalSettingsData} = useGlobalSettingsContentful()

    const image = useMemo(() => {
        const {title, file = {}} = globalSettingsData?.defaultProductMedia ?? {}
        return {
            title,
            url: file?.url
        }
    }, [globalSettingsData])

    return (
        <>
            {image && (
                <Image
                    alt={image?.title || 'Image'}
                    src={`${image?.url}`}
                    fallback={<Box background="gray.100" boxSize="full" />}
                />
            )}
        </>
    )
}

export default ItemImageDefault
